import type { Doc } from "../../convex/_generated/dataModel";

type FoodEntry = Doc<"foodEntries">;

export type MacroPatch = {
  readonly proteinG?: number;
  readonly carbsG?: number;
  readonly fatG?: number;
  readonly fiberG?: number;
};

export function adjustKnownMacroTotal(
  total: number | null,
  previous: number | undefined,
  next: number | undefined,
): number | null {
  if (previous === next) return total;
  if (total === null) return next === undefined ? null : next;
  return total + (next ?? 0) - (previous ?? 0);
}

function parseMacroInput(value: string, original: number | undefined): number | undefined | null {
  const trimmed = value.trim();
  if (trimmed.length === 0) return original;
  const parsed = Number(trimmed);
  if (!Number.isFinite(parsed) || parsed < 0) return null;
  return parsed;
}

export function buildMacroPatch(
  entry: FoodEntry,
  form: {
    readonly protein: string;
    readonly carbs: string;
    readonly fat: string;
    readonly fiber: string;
  },
): MacroPatch | null {
  const proteinG = parseMacroInput(form.protein, entry.proteinG);
  const carbsG = parseMacroInput(form.carbs, entry.carbsG);
  const fatG = parseMacroInput(form.fat, entry.fatG);
  const fiberG = parseMacroInput(form.fiber, entry.fiberG);
  if (proteinG === null || carbsG === null || fatG === null || fiberG === null) {
    return null;
  }
  return {
    ...(proteinG === undefined ? {} : { proteinG }),
    ...(carbsG === undefined ? {} : { carbsG }),
    ...(fatG === undefined ? {} : { fatG }),
    ...(fiberG === undefined ? {} : { fiberG }),
  };
}
